import { VariantProps, cva } from 'class-variance-authority';

export const switchStyles = cva(
  [
    'w-40',
    'h-24',
    'rounded-16',
    'flex',
    'group-data-[selected="true"]:justify-end',
    'group-data-[disabled="true"]:bg-grayscale300',
  ],
  {
    variants: {
      intent: {
        active: [
          'p-[3px]',
          'bg-primary50',
          'border',
          'border-primaryMain',
          'group-data-[selected="true"]:bg-primaryMain',
          'group-data-[selected="true"]:hover:bg-primary600',
        ],
        'on/off': [
          'bg-grayscale100',
          'hover:bg-grayscale200',
          'group-data-[selected="true"]:bg-success200',
          'group-data-[selected="true"]:hover:bg-success300',
          'p-4',
        ],
      },
    },
    defaultVariants: {
      intent: 'active',
    },
  },
);

export const switchStylesIndicator = cva(['block', 'size-16', 'rounded-full'], {
  variants: {
    intent: {
      active: [
        'bg-primaryMain',
        'group-data-[selected="true"]:bg-grayscale0',
        'group-data-[disabled="true"]:bg-grayscale50',
      ],
      'on/off': ['bg-grayscale0'],
    },
  },
  defaultVariants: {
    intent: 'active',
  },
});

export type SwitchStylesVariants = VariantProps<typeof switchStyles>;
